export const RF_VOICE_COUNT = 75
export const RF_INSTRUMENT_COUNT = 25
